export default __webpack_public_path__ + "static/media/nmet.9fb6506a.jpg";